function brandsApiFactory(storefrontApiClient) {
  const brandsApi = {
    getBrands(params) {
      return storefrontApiClient.get('/getBrands', {
        params,
      });
    },
  };

  return brandsApi;
}

export default brandsApiFactory;
